export default __webpack_public_path__ + "locales/it/ChangeUserTypeDialog.json?hash=79c02c9c7f1bc487a4c41b20a156c26a";